import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
/** Global loading-state service backing the app-wide spinner; toggled by the loading HTTP interceptor. */
export class LoadingService {
  private readonly loading$ = signal<boolean>(false);
  /** Readonly signal exposed to components/templates to render the loading indicator. */
  public readonly isLoading$ = this.loading$.asReadonly();

  /** Marks the application as busy (shows the loading indicator). */
  public show(): void {
    this.loading$.set(true);
  }

  /** Clears the busy state (hides the loading indicator). */
  public hide(): void {
    this.loading$.set(false);
  }
}
